var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLoaderTwoArrow = function SvgLoaderTwoArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#9FA8B9",
    clipPath: "url(#loader_two_arrow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10.03 10.03 0 0 1 7.12 3H16a1 1 0 1 0 0 2h4.14A1.86 1.86 0 0 0 22 5.14V1a1 1 0 0 0-2 0v2.08A11.98 11.98 0 0 0 .05 10.9a1 1 0 0 0 1.66.85c.19-.16.3-.38.33-.63A10.01 10.01 0 0 1 12 2Zm10.95 10a.98.98 0 0 0-.99.88A9.99 9.99 0 0 1 4.88 19H8a1 1 0 1 0 0-2H3.86A1.86 1.86 0 0 0 2 18.86V23a1 1 0 1 0 2 0v-2.08a11.98 11.98 0 0 0 19.95-7.82 1 1 0 0 0-1-1.1Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "loader_two_arrow_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgLoaderTwoArrow;